
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[newsTypeUrl]",
      function () {
        return require("private-next-pages/news/[newsTypeUrl]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[newsTypeUrl]"])
      });
    }
  